// For Local Development on the Current Device
// export const BASE_URL = (typeof process === 'object') ? process.env.PUBLIC_URL : "http://localhost:3001";

// Tanmay HotSpot
// export const BASE_URL = (typeof process === 'object') ? process.env.PUBLIC_URL : "http://10.194.235.179:3001";

// Tanmay's Wi-Fi
// export const BASE_URL = (typeof process === 'object') ? process.env.PUBLIC_URL : "http://192.168.29.130:3001";

// CS Infocomm Wi-Fi
// export const BASE_URL = (typeof process === 'object') ? process.env.PUBLIC_URL : "http://192.168.3.15:3001";

// Production URL
export const BASE_URL = (typeof process === 'object') ? process.env.PUBLIC_URL : "https://joglekarkul.com";